import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicationInfosResponse } from '../types'

export const useApplication = ({
  id
}: {
  id?: number
}): UseQueryResult<ApplicationInfosResponse, Error> => {
  return useQuery({
    queryKey: ['applications', id],
    queryFn: async () =>
      await fetchApiWithToken<ApplicationInfosResponse>({
        method: 'get',
        url: `/v1/applications/${id}`
      }),
    enabled: !!id
  })
}
